<script lang="ts" setup>
import { validadorDeNombreDeUsuario } from '@idem/common/validators/validador-de-nombre-de-usuario';
import TextField from '@idem/common/components/text-field.component.vue';

const props = defineProps<{ username?: string }>();
const emit = defineEmits(['error', 'update']);
</script>

<template>
  <TextField
    :validator="validadorDeNombreDeUsuario"
    :value="props.username"
    field="usuario"
    label="Usuario"
    @error="(e: string) => emit('error', e)"
    @update="(e: any) => emit('update', e)"
  />
</template>

<style scoped></style>
